import React, { ReactElement } from 'react';
import { CustomError } from 'form/yup/reactHookFormResolver';
import { InputError } from 'form/components/InputWrapper/InputWrapper.styled';

type Props = {
  error: CustomError[] | CustomError;
  customErrorMessages?: CustomErrorMessage[];
  showMultipleErrors?: boolean;
};

export interface CustomErrorMessage {
  type: string;
  render: (error: CustomError) => ReactElement | undefined;
}

const CustomErrorMessageComponent: React.FC<Props> = ({ error, customErrorMessages, showMultipleErrors = false }) => {
  const foundCustomErrors = customErrorMessages
    ? customErrorMessages.filter(
        (customErrorMessage: CustomErrorMessage) => Array.isArray(error) && customErrorMessage.type === error[0].type,
      )
    : [];

  if (foundCustomErrors.length !== 0 && Array.isArray(error)) {
    return <>{foundCustomErrors[0].render(error[0])}</>;
  }

  return showMultipleErrors ? (
    <>
      {Array.isArray(error) ? (
        error.map((error: any, index: number) => <InputError key={index}>{error.message}</InputError>)
      ) : (
        <InputError>{error.message}</InputError>
      )}
    </>
  ) : (
    <InputError>{Array.isArray(error) ? error[0].message : error.message}</InputError>
  );
};

export default CustomErrorMessageComponent;
